import React, { useState } from 'react';
import { PageTitleWithToolTip } from '../../Common';
import { Grid, IconButton, Collapse, Alert } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";
import { containerResponsiveStyle } from './styles';

const SiteServiceLayout = ({ title, onClose, actionButton, alert, children }) => {
    const [alertOpen, setAlertOpen] = useState(true);

    return (
        <>
            <Grid
                container
                spacing={2}
                sx={{
                    mt: { xs: 2, md: 0 },
                    ...containerResponsiveStyle
                }}
            >
                <Grid item xs={"auto"}>
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                    >
                        <CloseIcon />
                    </IconButton>
                </Grid>
                <Grid item xs={"auto"} md={6}>
                    <PageTitleWithToolTip pageTitle={title} />
                </Grid>
                <Grid item xs={12} md sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    {actionButton}
                </Grid>
                {alert && (
                    <Grid item xs={12}>
                        <Collapse in={alertOpen}>
                            <Alert severity={alert.severity || "info"} onClose={() => setAlertOpen(false)}>
                                {alert.message}
                            </Alert>
                        </Collapse>
                    </Grid>
                )}
            </Grid>
            {children}
        </>
    );
};

export default SiteServiceLayout;
